export default "images/travel-background-unsplash.png";